/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Meal_LunchInputs */

const en_for_whom_meal_lunch = /** @type {(inputs: For_Whom_Meal_LunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunch`)
};

const pl_for_whom_meal_lunch = /** @type {(inputs: For_Whom_Meal_LunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiad`)
};

/**
* | output |
* | --- |
* | "Lunch" |
*
* @param {For_Whom_Meal_LunchInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_meal_lunch = /** @type {((inputs?: For_Whom_Meal_LunchInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Meal_LunchInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_meal_lunch(inputs)
	return en_for_whom_meal_lunch(inputs)
});